import { Error429Form } from '@features/error/components';

function Error429() {
  return <Error429Form />;
}

export default Error429;
